module.exports = __webpack_public_path__ + "static/aboutus-image-33b193d8d11762fd9ac3e1a9909d55c6.png";